import React from "react";
import * as Styled from "./styles";
import { Typography } from "@mui/material";
import {
  SellOutlined as SellOutlinedIcon,
  LocationOn as LocationOnIcon,
} from "@mui/icons-material";
import { CheckoutItemDataProps } from "store/modules/Checkout/types.store";
import { formatTimeLocal, getRelativeDayLabel } from "utils/dateUtils";
import { formatByText } from "utils";
import { formatStreetAddress } from "utils/formatByText";

import { addHours } from "date-fns";

export const ScheduledOrderCard = ({
  item,
}: {
  item: CheckoutItemDataProps;
}) => {
  return (
    <Styled.ScheduledOrderCard>
      <Styled.ScheduledOrderCardClientName>
        <Typography variant="subtitle1">{item.customer.name}</Typography>
      </Styled.ScheduledOrderCardClientName>
      <Styled.ScheduledOrderCardLocationContainer>
        <LocationOnIcon fontSize="small" />
        <Styled.ScheduledOrderCardLocation>
          <Typography variant="subtitle2">
            {formatStreetAddress(item.delivery.address)}
          </Typography>

          <Typography variant="caption">
            {item.delivery.address.neighborhood}
          </Typography>
        </Styled.ScheduledOrderCardLocation>
      </Styled.ScheduledOrderCardLocationContainer>
      <Styled.ScheculedOrderCardTimeRow>
        <Styled.ScheculedOrderCardTime>
          <SellOutlinedIcon fontSize="small" />
          <Typography variant="caption">
            {item.scheduling.startAt ? (
              <>
                Agendado para {getRelativeDayLabel(item.scheduling.startAt)}{" "}
                entre {formatTimeLocal(new Date(item.scheduling.startAt))} e{" "}
                {formatTimeLocal(
                  addHours(new Date(item.scheduling.startAt), 1),
                )}
              </>
            ) : (
              "Agendamento pendente"
            )}
          </Typography>
        </Styled.ScheculedOrderCardTime>
        <Styled.ScheculedOrderCardItem>
          {item.items.map((product) => (
            <React.Fragment key={product.id}>
              <img
                src={product.imageUrl}
                alt={product.name}
                width={42}
                height={42}
              />
              <Typography variant="caption" key={product.id}>
                {product.quantity}{" "}
                {formatByText.formatProductNameAndDescription(
                  product.name,
                  product.description,
                )}
              </Typography>
            </React.Fragment>
          ))}
        </Styled.ScheculedOrderCardItem>
      </Styled.ScheculedOrderCardTimeRow>
    </Styled.ScheduledOrderCard>
  );
};
